<template>
  <v-flex
    v-if="item"
    xs12
    sm6
    md4
    xl3
    class="mb-3"
  >
    <v-card
      :to="{ name: item.link }"
      :disabled="item.disabled || false"
      height="120"
      hover
    >
      <v-layout>
        <v-flex xs2>
          <v-icon
            color="grey"
            large
            class="ml-2 pl-1 mt-1"
          >
            {{ item.icon }}
          </v-icon>
        </v-flex>
        <v-flex
          xs10
          class="pl-3 mr-2"
        >
          <div
            :class="item.disabled ? 'text--disabled' : ''"
            class="headline primary--text mt-0"
          >
            {{ $t(item.title) }}
          </div>
          <div class="grey--text">
            {{ $t(item.description) }}
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'SettingsOptionCard',

  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>
